
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IDefaultEmail } from "@tylertech/tyler-api-types";

/**
 * DefaultEmailService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class DefaultEmailService {
    private readonly $apiService = inject(ApiService);
    
    EmailTest(): Promise<any> {
        return this.$apiService.sendAuth("IDefaultEmailService/EmailTest");
    }
    GetEmailList(entityIds: string[]): Promise<IDefaultEmail[]> {
        return this.$apiService.sendAuth("IDefaultEmailService/GetEmailList", entityIds);
    }
    GetEmailTestInfo(): Promise<any> {
        return this.$apiService.sendAuth("IDefaultEmailService/GetEmailTestInfo");
    }
    GetEmailTestMetadata(): Promise<any> {
        return this.$apiService.sendAuth("IDefaultEmailService/GetEmailTestMetadata");
    }
    ShowEmailTest(): Promise<boolean> {
        return this.$apiService.sendAuth("IDefaultEmailService/ShowEmailTest");
    }
}
